export const enum GlobalEvent {
  REFRESH_CREDITS = "REFRESH_CREDITS",
}